import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "p-fluid p-component p-formgrid p-grid p-input-filled" }
const _hoisted_2 = { class: "p-field p-col-6" }
const _hoisted_3 = { for: "countryCode" }
const _hoisted_4 = {
  key: 0,
  class: "p-error"
}
const _hoisted_5 = { class: "p-field p-col-6" }
const _hoisted_6 = { for: "description" }
const _hoisted_7 = {
  key: 0,
  class: "p-error"
}
const _hoisted_8 = { class: "p-field p-col-6" }
const _hoisted_9 = { for: "name" }
const _hoisted_10 = {
  key: 0,
  class: "p-error"
}
const _hoisted_11 = { class: "p-field p-col-12" }
const _hoisted_12 = { for: "active" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Checkbox = _resolveComponent("Checkbox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("label", _hoisted_3, _toDisplayString(_ctx.$t('Squeeze.System.CountryCode')) + " *", 1),
      _createVNode(_component_InputText, {
        id: "countryCode",
        modelValue: _ctx.value.countryCode,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.value.countryCode) = $event)),
        class: _normalizeClass({'p-invalid':_ctx.v$.countryCode.$invalid && _ctx.showErrorMessage}),
        onChange: _ctx.update,
        disabled: _ctx.language.id,
        autofocus: ""
      }, null, 8, ["modelValue", "class", "onChange", "disabled"]),
      (_ctx.v$.countryCode.$invalid && _ctx.showErrorMessage)
        ? (_openBlock(), _createElementBlock("small", _hoisted_4, _toDisplayString(_ctx.$t('Forms.Val.MissingRequired', { field: _ctx.$t('Squeeze.System.CountryCode')})), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.$t('Squeeze.Locators.Description')) + " *", 1),
      _createVNode(_component_InputText, {
        id: "description",
        modelValue: _ctx.value.description,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.value.description) = $event)),
        class: _normalizeClass({'p-invalid':_ctx.v$.description.$invalid && _ctx.showErrorMessage}),
        onChange: _ctx.update,
        disabled: _ctx.language.id
      }, null, 8, ["modelValue", "class", "onChange", "disabled"]),
      (_ctx.v$.description.$invalid && _ctx.showErrorMessage)
        ? (_openBlock(), _createElementBlock("small", _hoisted_7, _toDisplayString(_ctx.$t('Forms.Val.MissingRequired', { field: _ctx.$t('Squeeze.Locators.Description')})), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.$t('Squeeze.System.Name')) + " *", 1),
      _createVNode(_component_InputText, {
        id: "name",
        modelValue: _ctx.value.name,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.value.name) = $event)),
        class: _normalizeClass({'p-invalid':_ctx.v$.name.$invalid && _ctx.showErrorMessage}),
        onChange: _ctx.update,
        disabled: _ctx.language.id
      }, null, 8, ["modelValue", "class", "onChange", "disabled"]),
      (_ctx.v$.name.$invalid && _ctx.showErrorMessage)
        ? (_openBlock(), _createElementBlock("small", _hoisted_10, _toDisplayString(_ctx.$t('Forms.Val.MissingRequired', { field: _ctx.$t('Squeeze.System.Name')})), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.$t('Squeeze.System.Active')), 1),
      _hoisted_13,
      _createVNode(_component_Checkbox, {
        id: "active",
        modelValue: _ctx.value.active,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.value.active) = $event)),
        binary: true,
        onChange: _ctx.update,
        disabled: _ctx.value.countryCode === 'en' || _ctx.value.countryCode === 'de'
      }, null, 8, ["modelValue", "onChange", "disabled"])
    ])
  ]))
}